import React, { Component, Fragment } from 'react'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import TextField from '@material-ui/core/TextField'
import { contentActions } from '../../../actions'
import SelectWrapped from '../../../components/SelectWrapped'
import { EdicaoField, CopyrightField, IsbnField } from '../../../components/Fields'
import { readOnly } from '../../../utils/permissions'

import { formatContentSelectValue, filterOptionsFunction } from '../../../utils'
import Typography from '@material-ui/core/Typography'
import * as API from '../../../api'

const styles = theme => ({
  layout: {
    height: 'calc(100% - 64px)',
    position: 'relative'
  },
  contentForm: {
    background: '#fff',
    height: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing.unit * 3,
    overflow: 'auto'
  },
  formGroup: {
    padding: '12px 0'
  },
  formControl: {
    margin: '12px 0'
  }
})

class Webinar extends Component {
  state = {
    specialities: []
  }

  render() {
    const {
      classes,
      content,
      handleChangeContent,
      handleChangeReference,
      formTouched,
      contentFormErrors,
      token
    } = this.props

    const isReadOnly = readOnly(content.tipo, token)

    return (
      <Fragment>
        <FormControl
          error={!((contentFormErrors.fields || {})['titulo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-titulo">Título</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, titulo: e.target.value })
            }}
            value={content.titulo}
            id="field-titulo"
          />
          {!((contentFormErrors.fields || {})['titulo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['titulo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangeContent({ ...content, autores: obj })
            }}
            error={!((contentFormErrors.fields || {})['autores'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.autores || [])}
            placeholder="Selecione..."
            name="react-select-chip-apresentadores"
            label="Apresentadores"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-apresentadores',
                loadOptions: API.authors.getSelectAuthors,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['autores'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['autores'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <FormControl
          error={!((contentFormErrors.fields || {})['codigo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-codigo">Código Vimeo</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, codigo: e.target.value })
            }}
            value={content.codigo}
            id="field-codigo"
          />
          {!((contentFormErrors.fields || {})['codigo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['codigo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['descricao'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-descricao">Resumo</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            multiline
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, descricao: e.target.value })
            }}
            value={content.descricao}
            id="field-descricao"
          />
          {!((contentFormErrors.fields || {})['descricao'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['descricao'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            className={classes.formControl}
            onChange={e => {
              handleChangeContent({ ...content, especialidades: e })
            }}
            value={formatContentSelectValue(content.especialidades || [])}
            error={!((contentFormErrors.fields || {})['especialidades'] || {}).valid && formTouched}
            placeholder="Selecione..."
            name="react-select-chip-especialidades"
            label="Especialidades"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-especialidades',
                options: [],
                loadOptions: API.specialities.getSelectSpecialities,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['especialidades'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['especialidades'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <div className={classes.formControl}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            className={classes.formControl}
            onChange={e => {
              handleChangeContent({ ...content, palavrasChave: e })
            }}
            error={!((contentFormErrors.fields || {})['palavrasChave'] || {}).valid && formTouched}
            value={formatContentSelectValue(content.palavrasChave || [])}
            placeholder="Selecione..."
            name="react-select-chip-keywords"
            label="Palavras-chave"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-keywords',
                loadOptions: API.keywords.getSelectKeywords,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((contentFormErrors.fields || {})['palavrasChave'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['palavrasChave'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>
        <FormControl
          error={!((contentFormErrors.fields || {})['pesoDA'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-pesoDA">Peso DA</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="number"
            onChange={e => {
              handleChangeContent({ ...content, pesoDA: e.target.value })
            }}
            value={content.pesoDA}
            id="field-pesoDA"
          />
          {!((contentFormErrors.fields || {})['pesoDA'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['pesoDA'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          error={!((contentFormErrors.fields || {})['idioma'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-idioma">Idioma</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangeContent({ ...content, idioma: e.target.value })
            }}
            value={content.idioma}
            id="field-idioma"
          />
          {!((contentFormErrors.fields || {})['idioma'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((contentFormErrors.fields || {})['idioma'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
        <fieldset>
          <legend>Programa</legend>
          <FormControl
            error={!((contentFormErrors.fields || {})['tituloModulo'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-tituloModulo">Título do programa</InputLabel>
            <Input
              disabled={isReadOnly}
              fullWidth
              required={'required'}
              type="text"
              onChange={e => {
                handleChangeContent({ ...content, tituloModulo: e.target.value })
              }}
              value={content.tituloModulo}
              id="field-tituloModulo"
            />
            {!((contentFormErrors.fields || {})['tituloModulo'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['tituloModulo'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <div className={classes.formControl}>
            <TextField
              disabled={isReadOnly}
              fullWidth
              error={
                !((contentFormErrors.fields || {})['autoresModulo'] || {}).valid && formTouched
              }
              onChange={e => {
                handleChangeContent({ ...content, autoresModulo: e })
              }}
              value={formatContentSelectValue(content.autoresModulo || [])}
              placeholder="Selecione..."
              name="react-select-chip-coordenadoresPrograma"
              label="Coordenadores do programa"
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                inputComponent: SelectWrapped,
                inputProps: {
                  multi: true,
                  filterOptions: filterOptionsFunction,
                  instanceId: 'react-select-chip-label',
                  id: 'react-select-chip-coordenadoresPrograma',
                  options: [],
                  loadOptions: API.authors.getSelectAuthors,
                  disableDelete: isReadOnly
                }
              }}
            />
            {!((contentFormErrors.fields || {})['autoresModulo'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['autoresModulo'] || {}).errorMessage}
              </Typography>
            ) : null}
          </div>
          <FormControl
            error={
              !((contentFormErrors.fields || {})['copyrightModulo'] || {}).valid && formTouched
            }
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-copyrightModulo">Ano de realização</InputLabel>
            <Input
              disabled={isReadOnly}
              fullWidth
              required={'required'}
              type="text"
              inputComponent={CopyrightField}
              onChange={e => {
                handleChangeContent({ ...content, copyrightModulo: e.target.value })
              }}
              value={content.copyrightModulo || ''}
              id="field-copyrightModulo"
            />
            {!((contentFormErrors.fields || {})['copyrightModulo'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['copyrightModulo'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <div className={classes.formControl}>
            <TextField
              disabled={isReadOnly}
              fullWidth
              onChange={e => {
                handleChangeContent({ ...content, especialidadesModulo: e })
              }}
              error={
                !((contentFormErrors.fields || {})['especialidadesModulo'] || {}).valid &&
                formTouched
              }
              value={formatContentSelectValue(content.especialidadesModulo || [])}
              placeholder="Selecione..."
              name="react-select-chip-especialidadesPrograma"
              label="Especialidades do Programa"
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                inputComponent: SelectWrapped,
                inputProps: {
                  multi: true,
                  filterOptions: filterOptionsFunction,
                  instanceId: 'react-select-chip-label',
                  id: 'react-select-chip-especialidadesPrograma',
                  options: [],
                  loadOptions: API.specialities.getSelectSpecialities,
                  disableDelete: isReadOnly
                }
              }}
            />
            {!((contentFormErrors.fields || {})['especialidadesModulo'] || {}).valid &&
            formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['especialidadesModulo'] || {}).errorMessage}
              </Typography>
            ) : null}
          </div>
        </fieldset>
        <fieldset>
          <legend>Curso</legend>
          <div className={classes.formControl}>
            <TextField
              disabled={isReadOnly}
              fullWidth
              className={classes.formControl}
              onChange={cursoReferencia => {
                handleChangeReference('curso', cursoReferencia)
              }}
              error={
                !((contentFormErrors.fields || {})['cursoReferencia'] || {}).valid && formTouched
              }
              value={content.cursoReferencia}
              placeholder="Selecione..."
              name="react-select-chip-preCadastro"
              label="Pré-cadastro"
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                inputComponent: SelectWrapped,
                inputProps: {
                  multi: false,
                  filterOptions: filterOptionsFunction,
                  instanceId: 'react-select-chip-label',
                  id: 'react-select-chip-preCadastro',
                  options: [],
                  loadOptions: API.preRegistrations.getSelectPreRegistrations('curso')
                }
              }}
            />
            {!((contentFormErrors.fields || {})['cursoReferencia'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['cursoReferencia'] || {}).errorMessage}
              </Typography>
            ) : null}
          </div>
          <FormControl
            error={!((contentFormErrors.fields || {})['tituloCurso'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-tituloCurso">Título do curso</InputLabel>
            <Input
              disabled={!!content.cursoReferencia || isReadOnly}
              fullWidth
              required={'required'}
              type="text"
              onChange={e => {
                handleChangeContent({ ...content, tituloCurso: e.target.value })
              }}
              value={content.tituloCurso}
              id="field-tituloCurso"
            />
            {!((contentFormErrors.fields || {})['tituloCurso'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['tituloCurso'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <div className={classes.formControl}>
            <TextField
              disabled={!!content.cursoReferencia || isReadOnly}
              fullWidth
              className={classes.formControl}
              onChange={e => {
                handleChangeContent({ ...content, autoresCurso: e })
              }}
              error={!((contentFormErrors.fields || {})['autoresCurso'] || {}).valid && formTouched}
              value={formatContentSelectValue(content.autoresCurso || [])}
              placeholder="Selecione..."
              name="react-select-chip-coordenadoresCurso"
              label="Coordenadores do curso"
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                inputComponent: SelectWrapped,
                inputProps: {
                  multi: true,
                  filterOptions: filterOptionsFunction,
                  instanceId: 'react-select-chip-label',
                  id: 'react-select-chip-coordenadoresCurso',
                  options: [],
                  loadOptions: API.authors.getSelectAuthors,
                  disableDelete: !!content.cursoReferencia || isReadOnly
                }
              }}
            />
            {!((contentFormErrors.fields || {})['autoresCurso'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['autoresCurso'] || {}).errorMessage}
              </Typography>
            ) : null}
          </div>
          <FormControl
            error={!((contentFormErrors.fields || {})['codigoProtheus'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-codigoProtheus">Código Protheus</InputLabel>
            <Input
              disabled={!!content.cursoReferencia || isReadOnly}
              fullWidth
              required={'required'}
              type="text"
              onChange={e => {
                handleChangeContent({ ...content, codigoProtheus: e.target.value })
              }}
              inputComponent={IsbnField}
              value={content.codigoProtheus || ''}
              id="field-codigoProtheus"
            />
            {!((contentFormErrors.fields || {})['codigoProtheus'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['codigoProtheus'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <FormControl
            error={!((contentFormErrors.fields || {})['copyrightCurso'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-copyrightCurso">Ano de realização</InputLabel>
            <Input
              disabled={!!content.cursoReferencia || isReadOnly}
              fullWidth
              required={'required'}
              type="text"
              inputComponent={CopyrightField}
              onChange={e => {
                handleChangeContent({ ...content, copyrightCurso: e.target.value })
              }}
              value={content.copyrightCurso || ''}
              id="field-copyrightCurso"
            />
            {!((contentFormErrors.fields || {})['copyrightCurso'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['copyrightCurso'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <FormControl
            error={!((contentFormErrors.fields || {})['edicaoCurso'] || {}).valid && formTouched}
            className={classes.formControl}
            fullWidth
          >
            <InputLabel htmlFor="field-edicaoCurso">Edição</InputLabel>
            <Input
              disabled={!!content.cursoReferencia || isReadOnly}
              fullWidth
              required={'required'}
              type="text"
              inputComponent={EdicaoField}
              onChange={e => {
                handleChangeContent({
                  ...content,
                  edicaoCurso: e.target.value
                })
              }}
              value={content.edicaoCurso || ''}
              id="field-edicaoCurso"
            />
            {!((contentFormErrors.fields || {})['edicaoCurso'] || {}).valid && formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['edicaoCurso'] || {}).errorMessage}
              </Typography>
            ) : null}
          </FormControl>
          <div className={classes.formControl}>
            <TextField
              disabled={!!content.cursoReferencia || isReadOnly}
              fullWidth
              onChange={e => {
                handleChangeContent({ ...content, especialidadesCurso: e })
              }}
              error={
                !((contentFormErrors.fields || {})['especialidadesCurso'] || {}).valid &&
                formTouched
              }
              value={formatContentSelectValue(content.especialidadesCurso || [])}
              placeholder="Selecione..."
              name="react-select-chip-especialidadesCurso"
              label="Especialidades do curso"
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{
                inputComponent: SelectWrapped,
                inputProps: {
                  multi: true,
                  filterOptions: filterOptionsFunction,
                  instanceId: 'react-select-chip-label',
                  id: 'react-select-chip-especialidadesCurso',
                  options: [],
                  loadOptions: API.specialities.getSelectSpecialities,
                  disableDelete: !!content.cursoReferencia || isReadOnly
                }
              }}
            />
            {!((contentFormErrors.fields || {})['especialidadesCurso'] || {}).valid &&
            formTouched ? (
              <Typography className={classes.errorMessage} noWrap color={'error'}>
                {((contentFormErrors.fields || {})['especialidadesCurso'] || {}).errorMessage}
              </Typography>
            ) : null}
          </div>
        </fieldset>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    content: state.content.content,
    contentFormErrors: state.content.contentFormErrors,
    formTouched: state.content.contentFormTouched,
    token: state.auth.token
  }
}
const mapDispatchToProps = dispatch => {
  return {
    handleChangeContent: content => {
      dispatch(contentActions.handleChangeContent(content))
    },
    handleChangeReference: (refType, reference) => {
      dispatch(contentActions.handleChangeReference({ refType, reference }))
    },
    setContentFormTouched: () => {
      return dispatch(contentActions.setContentFormTouched())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(Webinar))



// WEBPACK FOOTER //
// ./src/containers/Content/ContentTypes/Podcast.js